import { Component } from "react";
import FollowupEquipmentsEPIFilters from "./FollowupEquipmentsEPIFilters";
import EquipmentsEPITable from "./EquipmentsEPITable";
import { getFiltersInstance } from "../../redux/epi/epiActions";
import withAuth from "../withAuth";
import { compose } from "redux";
import { connect } from "react-redux";

class MyEquipmentsEPI extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filtersInstance: getFiltersInstance(true, false),
        };
    }

    render() {
        let orderEquipmentsEPI = this.props.equipmentsEPI;
        orderEquipmentsEPI.sort(function (a, b) {
            if (!a.validity_end_date) {
                return -1;
            }
            if (!b.validity_end_date) {
                return 1;
            }
            return new Date(a.validity_end_date) - new Date(b.validity_end_date);
        });

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top without-side-padding flex-div flex-grow-1">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding flex-div flex-grow-1">
                    <FollowupEquipmentsEPIFilters
                        classes={this.props.classes}
                        equipmentsEPI={orderEquipmentsEPI}
                        filtersInstance={this.state.filtersInstance}
                        myEquipmentsEPI
                    />
                    <div className="col-lg-12 flex-div flex-grow-1">
                        {
                            <EquipmentsEPITable
                                equipmentsEPI={orderEquipmentsEPI}
                                filtersInstance={this.state.filtersInstance}
                                myEquipmentsEPI
                            />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        equipmentsEPI: state.equipmentsEPI.myEquipmentsEPI,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFiltersInstance: (myEquipmentsEPI, coworkersEquipmentsEPI) =>
            dispatch(getFiltersInstance(myEquipmentsEPI, coworkersEquipmentsEPI)),
    };
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(MyEquipmentsEPI);
